import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LetDirective } from '@ngrx/component';
import { TranslateModule } from '@ngx-translate/core';

import { GaEventClickDirective } from '@personal-area/global/gtm';
import { TooltipCopyLinkComponent } from '@personal-area/global/ui';

import { AccountViewerPasswordComponent } from './account-viewer-password.component';

@NgModule({
  declarations: [AccountViewerPasswordComponent],
  exports: [AccountViewerPasswordComponent],
  imports: [CommonModule, TranslateModule, TooltipCopyLinkComponent, LetDirective, GaEventClickDirective],
})
export class AccountViewerPasswordModule {
}
